import React from "react";
import {
  SonicGameSelectionData,
  SonicGameSelectionItem,
} from "../../../common/classes/SonicGameSelection";
import { SonicTermData } from "../../../common/classes/SonicTerm";
import ListWrapper from "../../../common/management/ListWrapper";
import LoadingSpinner from "../../../common/LoadingSpinner";
import GameSelectionItemList from "./GameSelectionItemList";

type Props = {
  isLoading: boolean;
  game?: SonicTermData;
  gameSelection?: SonicGameSelectionData;
  handleUpdate: (game_id: string, item: SonicGameSelectionItem) => void;
  handleDelete: (id: string, field: string, itemId: string) => void;
  handleShuffle: (
    id: string,
    field: string,
    shuffledIndex: Array<number>
  ) => void;
};
const GameSelectionDetail: React.FC<Props> = ({
  isLoading,
  game,
  gameSelection,
  handleUpdate,
  handleDelete,
  handleShuffle,
}) => {
  return (
    <>
      <ListWrapper
        pageTitle={game ? `「${game.name}」の項目設定` : "ゲーム項目設定"}
        tabs={["ランク"]}
        btnTitle="一覧へ"
        icon={["fal", "chevron-left"]}
        link={"/admin/game-selection"}
        handler={() => {}}
      >
        {isLoading ? (
          <LoadingSpinner space={1} admin_page={true} />
        ) : !game ? (
          <></>
        ) : (
          <>
            <GameSelectionItemList
              id={gameSelection?.id}
              gameId={game.id}
              label="ランク"
              items={gameSelection ? gameSelection.rank : []}
              handleUpdate={handleUpdate}
              field="rank"
              handleDelete={handleDelete}
              handleShuffle={handleShuffle}
            />
          </>
        )}
      </ListWrapper>
    </>
  );
};

export default GameSelectionDetail;
